<i18n src="../../locales/lang.json"></i18n>
<template>
  <div class="container-fluid">

    <div class="row mt-3">
      <div class="col-12 custom-form-label px-0">
        {{$t('name')}}
      </div>
    </div>
    <div class="row mt-1">
      <div class="col px-0">
        <input type="text" class="form-control" v-model="summary" />
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-12 custom-form-label px-0">
        {{$t('description')}}
      </div>
    </div>
    <div class="row mt-1">
      <div class="col-12 px-0">
        <textarea class="form-control" v-model="description" v-bind:placeholder="$t('enter_description')" style="border:1px solid #ccc !important; padding:5px;"></textarea>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-12 custom-form-label px-0">
        {{$t('date')}}
      </div>
    </div>
    <div class="row mt-1">
      <div class="col-12 custom-form-label px-0">
        <input-inline-daterange ref="daterange" @changed="doChangeDate"></input-inline-daterange>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-12 custom-form-label px-0">
        <input-checkbox @input="setHolliday" ref="checkboxHolliday" id="chk_holliday"
                        name="chk_teamEmailOnAdd" v-bind:checked="visibility == 'public'"
                        v-bind:text="$t('holliday')"></input-checkbox>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-lg-12 form-group pt-3 px-0">
        <a style="color:inherit" v-show="mode == 'add'" @click="addCalenderEvent" class="btn btn-link skin btn-primary pull-right">{{$t('add')}}</a>
        <a style="color:inherit" v-show="mode == 'update'" @click="updateCalenderEvent" class="btn btn-link skin btn-primary pull-right">{{$t('update')}}</a>
        <a style="color:inherit" @click="cancel" class="btn skin btn-link pull-right mr-1">{{$t('cancel')}}</a>
      </div>
    </div>
    <div class="row">
      <div class="col-12 custom-form-label px-0">
        <input-date-navigation ref="dateNavigation" v-bind:text="$t('events')" @changed="dateNavigationChanged"></input-date-navigation>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-12 custom-form-label px-0">

        <basic-table ref="eventTable" @onrowclick="rowclick" enableedit="true" v-bind:responsive="true" tablecss="skin">
          <template slot="menu" scope="childDataScope">
            <a @click="doRowDelete(childDataScope.row.id)" href="#" class="dropdown-item">{{$t('delete')}}</a>
          </template>
        </basic-table>
      </div>
    </div>
  </div>
</template>

<script>

  import moment from 'moment'

  import InputText from "../form-components/input-text.vue";

  export default {
    name: "importantdates-editor",
    components: {
      InputText
    },
    props: {
      
    },
    data() {
      return {
        mode: 'add',
        summary: '',
        description: '',
        startdate: null,
        enddate: null,
        id: null,
        searchStart: null,
        searchEnd: null,
        visibility:null,
      };
    },
    methods: {
      setHolliday(value, name) {
        if (value == true)
          this.visibility = "public";
        else
          this.visibility = null;
      },
      doRowDelete(id) {
        this.deleteImportantDate(id);
      },
      cancel() {
        this.resetForm();
        this.$emit("cancel", "date")
        this.$root.$emit("cancel_date")
      },
      resetForm() {
        this.mode = 'add'
        this.id = null;
        this.summary = '';
        this.description = '',
        this.startdate = moment(new Date());;
        this.enddate = moment(new Date()).add(1, 'days');;
        this.$refs.daterange.clearDates();
        this.visibility = null;
        this.$forceUpdate();
        //alert("after resetForm");
      },
      rowclick(index, row) {
        this.mode = 'update';
        this.id = row.id;
        this.summary = row.summary;
        this.visibility = row.visibility;
        this.description = row.description;
        this.startdate = moment(row.startDateString);
        this.enddate = moment(row.endDateString);
        
        this.$refs.daterange.setDateRange(moment(row.startDateString), moment(row.endDateString));
      },

      dateNavigationChanged(start, end, mode) {

        if (mode == "day") {
          //this.searchStart = start;
          //this.searchEnd = start;
          //this.getEvents(moment(start).format("YYYY-MM-DD"), moment(end).format("YYYY-MM-DD"))
          //return;
        }
        this.searchStart = start;
        this.searchEnd = end;
        this.getEvents(moment(start).format("YYYY-MM-DD"), moment(end).format("YYYY-MM-DD"))
      },
      deleteImportantDate(id) {
        try {
          var url = '/api/Calender/v1/Events/' + id;
          this.$http.delete(url).then(async response => {
            this.refreshEvents();
          });
        }
        catch (err) {
          
        }
      },
      doChangeDate(start, end) {
        this.startdate = start;
        this.enddate = end;
      },
      refreshEvents() {
        //alert("refreshEvents")
        this.getEvents(moment(this.searchStart).format("YYYY-MM-DD"), moment(this.searchEnd).format("YYYY-MM-DD"))
      },
      getId() {
        return this._uid;
      },

      handleRefresh(val) {
        this.$forceUpdate();
      },
      updateCalenderEvent() {
        var data = {
          Id: this.id,
          StartDate: null,
          EndDate: null,
          Name: this.summary,
          Description: this.description,
          Visibility: this.visibility
        };

        if (this.startdate != null) {
          data.StartDate = moment(this.startdate).format("YYYY-MM-DD HH:mm:ss")
        }

        if (this.enddate != null) {
          data.EndDate = moment(this.enddate).format("YYYY-MM-DD HH:mm:ss")
        }
        var thisContext = this;
        var postString = JSON.stringify(data);
        var response = this.$http.patch(
          '/api/Calender/v1/Events/' + this.id,
          postString,
          {
            headers: {
              'Content-Type': 'application/json',
              "Accept": "application/json"
            }
          }
        )
          .then(response => {
            setTimeout(thisContext.resetForm, 100)
            setTimeout(thisContext.refreshEvents, 100)
            
            
          });
      },
      addCalenderEvent() {
        var data = {
          StartDate: null,
          EndDate: null,
          Name: this.summary,
          Description: this.description,
          Visibility: this.visibility
        };

        if (this.startdate != null) {
          data.StartDate = moment(this.startdate).format("YYYY-MM-DD HH:mm:ss")
        }

        if (this.enddate != null) {
          data.EndDate = moment(this.enddate).format("YYYY-MM-DD HH:mm:ss")
        }

        var thisContext = this;
        var postString = JSON.stringify(data);
        var response = this.$http.post(
          '/api/Calender/v1/Events',
          postString,
          {
            headers: {
              'Content-Type': 'application/json',
              "Accept": "application/json"
            }
          }
        )
          .then(response => {
            setTimeout(thisContext.resetForm, 100)
            setTimeout(thisContext.refreshEvents, 100)
           });
      },
      getEvents(startDateString, endDateString) {
        var response = this.$http.get('/api/Calender/v1/Events?startDate=' + startDateString + '&endDate=' + endDateString)
          .then(response => {


            var items = [];

            for (var i = 0; i < response.data.length; i++) {
              items.push(
                {
                  summary: response.data[i].Summary,
                  id: response.data[i].Id,
                  startDateString: response.data[i].StartDateString,
                  endDateString: response.data[i].EndDateString,
                  description: response.data[i].Description,
                  visibility: response.data[i].Visibility
                })
            }

            //alert(JSON.stringify(items))

            var headerdata =
              [
                { headername: this.$t('name'), columnname: "summary", css: "", datahide: "", enabled: true, databreakpoints: "" },
                { headername: this.$t('description'), columnname: "description", css: "", datahide: "", enabled: false, databreakpoints: "" },
                { headername: "id", columnname: "id", css: "", datahide: "", enabled: false, databreakpoints: "" },
                { headername: this.$t('start_date'), columnname: "startDateString", css: "", datahide: "", enabled: true, databreakpoints: "" },
                { headername: this.$t('end_date'), columnname: "endDateString", css: "", datahide: "", enabled: true, databreakpoints: "" },
              ]
            this.$refs.eventTable.setData(headerdata, items);

            //this.$refs.ticker.end(this.$refs.container.getAttribute('id'));
          });
      },
    },
    computed: {
      
    },
    watch: {
      
    },
    mounted() {
      var mom = this.$store.getMomentLocale(new Date());
      var startOfMonth = mom.startOf('month').format('YYYY-MM-DD');
      var endOfMonth = mom.endOf('month').format('YYYY-MM-DD');

      this.searchStart = startOfMonth;
      this.startdate = moment(new Date());
      this.enddate = moment(new Date()).add(1, 'days');
      this.searchEnd = endOfMonth;
      this.refreshEvents();
      this.$refs.daterange.setDateRange(moment(this.startdate), moment(this.enddate));
    },
    created() {

    },
  };

</script>

<style scoped>
  

</style>



// WEBPACK FOOTER //
// src/components/startpage/importantdates-editor.vue